@if (displayBanner) {
  <div class="banner-wrapper">
    <div class="banner">
      <div class="banner-content">
        <p class="banner-text">
          {{ '_ui.cookiesBanner.message' | translate }}
          <a
            target="_blank"
            rel="noopener noreferrer"
            [attr.href]="baseUrlApp + '/legal/cookies-policy'"
          >
            {{ '_ui.cookiesBanner.link' | translate }}
          </a>
        </p>
        <myre-action-button
          (click)="accept()"
          [type]="'primary'"
          [color]="'red'"
          class="btn btn-lg btn-secondary"
        >
          {{ '_ui.cookiesBanner.button' | translate }}
        </myre-action-button>
      </div>
      <div class="banner-close-wrapper">
        <span
          (click)="close()"
          id="cookie-banner-close"
          class="banner-close myre-icon-close"
        >
        </span>
      </div>
    </div>
  </div>
}
